export const DS_PICKER_CLASSES = {
  Root: "ds-picker",
  Content: "ds-picker__content",
  Footer: "ds-picker__footer",
} as const;
